module.exports = __webpack_public_path__ + "static/media/worry-time@3x.645c9552.png";